import logo from './../assets/frank.png';
import React from "react";
import './home.css';

export function Home() {
  return (
    <div className="Home">
      <header className="Home-header">
        <img src={logo} className="Home-logo" alt="logo" />
        <h1>
          Hi! I'm Frank. 
        </h1> 
        <h4>
          I'm currently a sophomore at Columbia looking to major in Electrical Engineering with a minor in Computer Science. I'm currently interested in exploring computer architecture. This is a website of some of the cool projects I've done. Please free feel to explore!
        </h4>
      </header>
    </div>
  );
}
